export default "__VITE_ASSET__BL17Rfwr__"